import { Opportunity, Category } from "@entities";
import { extender } from "@shared/backend/class-extender";
import HyperEntity from "@shared/backend/hyper-entity.decorator";
import { Fields, Relations } from "remult";
import { OpportunityCategoryEntityConfig } from "./config";
import { OpportunityCategoryFilters } from "./filters";
import { OpportunityCategoryMethods } from "./methods";

@HyperEntity("opportunity-category", OpportunityCategoryEntityConfig)
export class OpportunityCategory extends extender(
  OpportunityCategoryFilters,
  OpportunityCategoryMethods,
) {
  @Fields.string({ dbName: "category_id" })
  categoryId = "";

  @Fields.string({ dbName: "opportunity_id" })
  opportunityId = "";

  @Relations.toOne(() => Category, "categoryId")
  category?: Category;

  @Relations.toOne(() => Opportunity, "opportunityId")
  opportunity?: Opportunity;

  @Fields.createdAt({ dbName: "created_at" })
  createdAt = new Date();

  @Fields.updatedAt({ dbName: "updated_at" })
  updatedAt = new Date();
}








